import * as React from "react";
import { useEffect } from "react";
import Box from "@mui/material/Box";
// import Slide from "@mui/material/Slide";
// import Grow from "@mui/material/Grow";
// import Zoom from "@mui/material/Zoom";
import Fade from "@mui/material/Fade";

function Carousel(props: any) {
  const images = props.images;
  const [activeStep, setActiveStep] = React.useState(0);
  const [stepCounter, setStepCounter] = React.useState(0);
  const [secondActiveStep, setSecondActiveStep] = React.useState(1);
  const [thirdActiveStep, setThirdActiveStep] = React.useState(0);
  const [slideIn, setSlideIn] = React.useState(true);
  const [secondSlideIn, setSecondSlideIn] = React.useState(false);
  const [thirdSlideIn, setThirdSlideIn] = React.useState(false);
  const [dummy, setDummy] = React.useState(true);
  const [preloadImage, setPreloadImage] = React.useState("");

  const maxSteps = images.length;
  const slideTimeout = 1500;
  const objectFit = "cover";

  function handleSwitch(
    setCurrentStateState: React.Dispatch<React.SetStateAction<number>>,
    n: number,
  ) {
    setCurrentStateState(n);
  }

  /*
  logic to cycle through images in carousel
  - MUI Slide in => slide*In true/false visible or not
  - 3 images and update the non transitioning image
    - e.g. 1 -> 2 update slide 3
  */
  const nextImage = () => {
    let nonVisibleStep;
    if (stepCounter + 2 <= maxSteps - 1) {
      nonVisibleStep = stepCounter + 2;
    } else {
      nonVisibleStep = stepCounter + 2 - maxSteps;
    }
    if (slideIn) {
      setSlideIn((prevSlideIn) => !prevSlideIn);
      setSecondSlideIn((prevSecondSlideIn) => !prevSecondSlideIn);
      handleSwitch(setThirdActiveStep, nonVisibleStep);
    } else if (secondSlideIn) {
      setSecondSlideIn((prevSecondSlideIn) => !prevSecondSlideIn);
      setThirdSlideIn((prevThirdSlideIn) => !prevThirdSlideIn);
      handleSwitch(setActiveStep, nonVisibleStep);
    } else if (thirdSlideIn) {
      setThirdSlideIn((prevThirdSlideIn) => !prevThirdSlideIn);
      setSlideIn((prevSlideIn) => !prevSlideIn);
      handleSwitch(setSecondActiveStep, nonVisibleStep);
    }
    if (stepCounter + 1 === maxSteps) {
      setStepCounter(0);
    } else {
      setStepCounter((prev) => prev + 1);
    }
    setDummy((prevDummy) => !prevDummy); // needed for state to update as expected
  };

  useEffect(() => {
    const interval = setInterval(() => {
      nextImage();
    }, 8000);
    return () => clearInterval(interval);
  }, [dummy]);

  // preload images:
  // useEffect(() => {
  //   let preloadImage = new Image();
  //   for (let i = 0; i++; i < images.length) {
  //     preloadImage.src = images[i].src;
  //   }
  // }, []);

  return (
    <>
      <Box
        sx={{
          position: "relative",
          height: "600px",
        }}
      >
        {/* <img src={preloadImage} style={{ display: "none" }}></img> */}
        <Box>
          <div
            style={{
              width: "100%",
              textAlign: "center",
              zIndex: 500,
              color: "white",
              backgroundColor: "#879981",
              // marginTop: "0.28em",
              top: "500px",
              position: "absolute",
              fontSize: "5em",
              fontFamily: "'seasons', 'Motiva Sans Bold', 'serif'",
            }}
          >
            Heart of Life Floral
          </div>
          <Fade
            // direction={slideIn ? "right" : "left"}
            in={slideIn}
            timeout={slideTimeout}
            easing={{ enter: "linear", exit: "linear" }}
            mountOnEnter
            unmountOnExit
          >
            <Box
              component="img"
              sx={{
                position: "absolute",
                display: "block",
                overflow: "hidden",
                width: "100%",
                marginTop: "2%",
                height: "500px",
                objectFit,
              }}
              src={images[activeStep].src}
              alt={images[activeStep].alt}
            />
          </Fade>
          <Fade
            // direction={secondSlideIn ? "right" : "left"}
            in={secondSlideIn}
            timeout={slideTimeout}
            easing={{ enter: "linear", exit: "linear" }}
            mountOnEnter
            unmountOnExit
          >
            <Box
              component="img"
              sx={{
                position: "absolute",
                display: "block",
                overflow: "hidden",
                width: "100%",
                marginTop: "2%",
                height: "500px",
                objectFit,
              }}
              src={images[secondActiveStep].src}
              alt={images[secondActiveStep].alt}
            />
          </Fade>
          <Fade
            // direction={thirdSlideIn ? "right" : "left"}
            in={thirdSlideIn}
            timeout={slideTimeout}
            easing={{ enter: "linear", exit: "linear" }}
            mountOnEnter
            unmountOnExit
          >
            <Box
              component="img"
              sx={{
                position: "absolute",
                display: "block",
                overflow: "hidden",
                width: "100%",
                marginTop: "2%",
                height: "500px",
                objectFit,
              }}
              src={images[thirdActiveStep].src}
              alt={images[thirdActiveStep].alt}
            />
          </Fade>
        </Box>
      </Box>
    </>
  );
}

export default Carousel;
